import { number, object, string } from "yup";
import { Data, stringMax } from "./utils";

export const leaseTemplateValidationSchema = object({
  nom: stringMax(250).required(" "),
  duree: number().integer().required(" "),
  type: stringMax(250).required(" "),
  content: string().required(" "),
});

export const LEASE_TEMPLATE_INITIAL_VALUE = {
  nom: "",
  duree: 1,
  type: "",
  content: "",
};

export class Lease extends Data {
  acompte = undefined;
  activite_exerce = undefined;
  article_specific = undefined;
  clauses_specifiques = undefined;
  complement_loyer = undefined;
  condition_paiement_solde = undefined;
  date_dernier_loyer = undefined;
  date_limite_paiement_solde = undefined;
  date_paiement_solde = undefined;
  detail_charges = undefined;
  echeance_bailleur = undefined;
  echeance_locataire = undefined;
  hour_end = undefined;
  hour_start = undefined;
  id_lease_template = undefined;
  is_meuble = undefined;
  join_notice = undefined;
  justif_complement_loyer = undefined;
  montant_dernier_travaux = undefined;
  montant_surcharge = undefined;
  nature_dernier_travaux = undefined;
  nombre_personne = undefined;
  pourcentage_acompte = undefined;
  preavis_bailleur = undefined;
  preavis_locataire = undefined;
  raison_mobilite = undefined;
  taxe_sejour = undefined;
  type_acompte = undefined;
  type_charge = undefined;
}
